module.exports = __webpack_public_path__ + "static/media/angryElephant.d2175392.svg";